export * from './tag-properties.model';
export * from './tag-properties.module';
export * from './tag-properties.types';
